<template>
  <div class="hardwareList-page">
    <div class="haeder-container black">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="all-container">
      <img src="../../assets/img/hardware/banner_bg.png" alt="" class="banner_bg">
      <div class="center-container">
        <div class="nav-search-container">
          <div class="search-container">
            <input type="text" v-model="keyWord" class="search-inp" @keyup.enter="submitBtn()" placeholder="请输入关键词">
            <div class="search-btn" @click="submitBtn()">
              <img src="../../assets/img/common/sousuo.png" alt="">
            </div>
          </div>
          <ul class="nav-list-container">
            <!-- <div class="nav-all-data-container">
              <span @click="changeGetData( '' )">
                全部
              </span>
            </div> -->
            <li class="nav-item-container" v-for="( item , key ) in goodsTypeData" :key="key">
              <span :class="[ item.isSelect ? 'isActive nav-item-name' : 'nav-item-name']" @click="changeGetData( item.id )">
                {{ item.name }}
              </span>
            </li>
          </ul>
        </div>
        <div class="listData-container" style="    min-height: 180px;">
          <ul class="list-container">
            <li class="item-container" v-for="( item , key ) in hardwareList" :key="key" @click="jumpDetails( item.id )">
              <div class="item-content-container">
                <span :class="'product-brand ' + 'brandBg1'" v-if=" item.brand ">{{ item.brand }}</span>
                <div class="product-img-container">
                  <img class="product-img" :src="item.image" alt="">
                </div>
                <p class="product-name" :title="item.title">{{ item.title }}</p>
                <p class="product-characteristic">{{ item.goodsDescribe ? item.goodsDescribe : item.title }}</p>
                <!-- <p class="product-price">
                  <span class="price-unit">
                    ￥
                  </span>
                  <span class="price-num">
                    {{ item.price ? item.price : '--' }}
                  </span>
                </p> -->
              </div>
            </li>
          </ul>
          <div class="no-more-data" v-if=" !isMoreData ">
            <span>
              暂无更多数据
            </span>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'
// import hardwareList from "@/static/hardwareList"
export default {
  name: 'hardwareList',
  components:{
    Header,
    Nav,
    Foot
  },
  watch: {
    keyWord: function( val ){
      if( val == '' ){
        this.pageNum = 1
        this.hardwareList = [] // 清空
        this.getGoodsInfoList()
      }
    },
    $route: function( to , form ){
      $(window).scrollTop(0)
      this.pageNum = 1
      this.hardwareList = [] // 清空
      this.dataType = to.query.id
      this.selectCurrent( this.dataType ) // 选中当前分类
      this.getGoodsInfoList()
    },
  },
  data(){
    return {
      hardwareList: [], // 硬件列表数据
      goodsTypeData: [
        {
          id: '',
          name: '全部',
          isSelect: true,
        },
         {
          id: '',
          name: '边缘计算',
          isSelect: false,
        },
        {
          id: '',
          name: '普通网关',
          isSelect: false,
        },
        // {
        //   id: '',
        //   name: '工业产线',
        //   isSelect: false,
        // },
        // {
        //   id: '',
        //   name: '消防能效',
        //   isSelect: false,
        // },
        {
          id: '',
          name: '气象环境',
          isSelect: false,
        },
        {
          id: '',
          name: '水质环境',
          isSelect: false,
        },
        {
          id: '',
          name: '农产林业',
          isSelect: false,
        },
        // {
        //   id: '',
        //   name: '工地公厕',
        //   isSelect: false,
        // },
       {
          id: '',
          name: '农业设备',
          isSelect: false,
        },
        // {
        //   id: '品牌馆',
        //   name: '品牌馆',
        //   isSelect: false,
        // },
      ],  // 搜索下面的分类数据
      pageNum: 1, // 页数
      pageSize: 20, // 条数
      keyWord: '', // 搜索关键字
      dataType: '', // 商品类型
      isMoreData: true, // 是否还有更多数据
    }
  },
  created () {
    // this.hardwareList = hardwareList
    window.addEventListener('scroll', this.onScroll); // 监听滚动条事件
    this.dataType = this.$route.query.id ? this.$route.query.id : ''
    this.init()
  },
  mounted() {
    let that = this
    // 滑动滚动条,获取数据
    // $(window).scroll(function() {
    //   var winH = $(window).height(),
    //   pageH = $(document.body).height();
    //   var scrollT = $(window).scrollTop(),
    //   scroll_result = (pageH - winH - scrollT) / winH;
    //   if(scroll_result < 0.2) {
    //     that.pageNum++
    //     that.getGoodsInfoList()
    //   }
    // })
  },
  methods: {
    init(){
      this.getGoodsType()
      this.getGoodsInfoList()
    },
    jumpDetails( id ){
      this.$router.push({
        name: 'hardwareDetails',
        query:{
          id: id
        }
      })
    },
    changeGetData( id ){ // 切换分类数据的时候
      this.pageNum = 1
      this.dataType = id
      this.hardwareList = [] // 清空
      if( this.dataType != '品牌馆' ){
        this.getGoodsInfoList()

      }else{
        this.getBrandList()
      }
      this.selectCurrent( id )
    },
    submitBtn(){ // 查询
      this.pageNum = 1
      this.hardwareList = [] // 清空
      this.getGoodsInfoList()
    },
    onScroll(  ){
      let that = this
      var winH = $(window).height(),
      pageH = $(document.body).height();
      var scrollT = $(window).scrollTop(),
      scroll_result = (pageH - winH - scrollT) / winH;
      if(scroll_result < 1.6) {
        that.pageNum++
        if( that.dataType != '品牌馆' ){
          that.getGoodsInfoList()

        }else{
          that.getBrandList()
        }
      }
    },
    selectCurrent( id ){
      // 选中当前点击的
      for( let j = 0 , leng = this.goodsTypeData.length ; j < leng ; j++ ){
        if( this.goodsTypeData[j].id == id ){
          this.goodsTypeData[j].isSelect = true
        }else{
          this.goodsTypeData[j].isSelect = false
        }
      }
    },
    getGoodsType(){ // 获取商品分类
      this.$api.hardware.getGoodsType().then( ( res ) =>{
        if( res.code == 200 ){
          let data = res.data
          // 下面的循环是为了,获取数据库中的id,防止id发生变化
          for( let i = 0 , len = data.length ; i < len ; i++ ){
            for( let j = 0 , leng = this.goodsTypeData.length ; j < leng ; j++ ){
              if(this.goodsTypeData[j].name == "农业设备"){
                this.goodsTypeData[j].id = 19
              }else if( this.goodsTypeData[j].name == data[i].name ){
                this.goodsTypeData[j].id = data[i].id
              }
            }
          }
        }
        this.selectCurrent( this.dataType ) // 选中当前分类
      })
    },
    getGoodsInfoList(){ // 获取商品列表
      this.$api.hardware.getGoodsInfoList(
        this.keyWord,
        this.pageNum,
        this.pageSize,
        this.dataType,
      ).then( ( res ) =>{
        if( res.code == 200 ){
          let data = res.data
          this.isMoreData = data.length ? true : false
          for( let i = 0 , len = data.length ; i < len ; i++ ){
            let str = data[i].goodsDescribe
            data[i].goodsDescribe = str.substr( 0 , 32 ) + '...'
          }
          this.hardwareList.push( ...data )
        }
      })
    },
    getBrandList(){ // 获取商品数据
      this.$api.hardware.getBrandList(
        this.pageNum,
        this.pageSize,
      ).then( ( res ) =>{
        if( res.code == 200 ){
          let data = res.data
          this.isMoreData = data.length ? true : false
          for( let i = 0 , len = data.length ; i < len ; i++ ){
            let str = data[i].goodsDescribe
            data[i].goodsDescribe = str.substr( 0 , 32 ) + '...'
          }
          this.hardwareList.push( ...data )
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
